import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  resultsMessage: {
    marginBottom: pxToRem(8),
    fontWeight: 600,
  },
  pagination: {
    marginLeft: pxToRem(0),
  },
  noResultsSentence: {
    marginTop: pxToRem(5),
    fontWeight: 400,
  },
  noActionRequiredText: {
    padding: pxToRem(20),
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  detailRowIconColor: {
    color: theme.palette.neutralTertiary,
  },
  searchSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    paddingBottom: pxToRem(25),
  },
  filter: {
    maxWidth: pxToRem(223),
    width: '100%',
  },
  search: {
    width: '100%',
  },
  createButton: {
    backgroundColor: theme.palette.themePrimary,
    textAlign: 'center',
    fontSize: '1rem',
    padding: pxToRem(15),
    maxWidth: pxToRem(120),
    color: `${theme.palette.white} !important`,
    selectors: {
      '&:hover': {
        backgroundColor: theme.palette.themePrimary,
        color: theme.palette.white,
        textDecoration: 'none',
      },
    },
  },
});
